import classNames from 'classnames';
import * as bd from 'react-basic-design';
import { calendar } from '../basic/calendar';
import { N } from '../basic/n';
import { NotifStatusChip, StatusChip } from '../basic/status-chip';

export const ToggleCell = ({ value, className = '', color = '' }) => (
    <>
        <bd.Toggle
            model={value}
            color={color}
            disabled
            disableRipple
            size="sm"
            className={classNames(className, value ? '' : 'opacity-50')}
        />
    </>
);

export const NumberCell = ({ value }) => <N>{value}</N>;

export const StatusCell = ({ value, title = '' }) => <StatusChip value={value} tooltip={title} />;
export const NotificationStatusCell = ({ value }) => <NotifStatusChip value={value} />;
export const LTRCell = ({ value }) => (
    <span className="ltr d-inline-block">
        <N>{value}</N>
    </span>
);

export const DateCell = ({ value, className = '', title = '' }) => {
    if (!value) return <></>;
    return (
        <span className={className} title={title}>
            {calendar.dateToString(value)}
        </span>
    );
};

export const DateDiff = ({ value, className = '' }) => (
    <N className={className}>{calendar.calculateTimeDiff(value)}</N>
);

export const DateTimeCell = ({ value = '', className = '' }) => {
    if (new Date(value).getFullYear() <= 1) return <></>;
    return (
        <span className={`d-inline-block ${className} ltr`}>
            <span className="d-inline-block">
                <span>{calendar.dateToString(value)}</span>&nbsp;
            </span>{' '}
            <span>{calendar.toHHMM(value)}</span>
        </span>
    );
};

export const TimeCell = ({ value, className }) => (
    <span className={`d-inline-block ${className} ltr`}>
        <N value={calendar.toHHMM(value)} />
    </span>
);

export const CountCell = ({ value, className }) => (
    <span
        className={`d-inline-block rounded-pill ltr px-2 py-1 m-1 ${className} ${value === 0 && 'alert-warning'}`}
    >
        <N>{value}</N>
    </span>
);
